export default class CollapsableBox {
    constructor($el) {
        this.$el = $el;
        this.$trigger = this.$el.querySelector('[data-collapsable-box-trigger]');

        if ( ! this.$trigger) {
            return;
        }

        this.$area = this.$el.querySelector('[data-collapsable-box-area]');

        if ( ! this.$area) {
            return;
        }

        this.$trigger.addEventListener('click', (e) => {
            e.preventDefault();

            this.$el.classList.toggle('active');
        });

        setTimeout(() => {
            this.$el.style.setProperty('--collapsable-box-max-height', `${this.$area.scrollHeight + 15}px`);
            this.$el.classList.add('animate');
        }, 50);
    }
}